import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OnboardingService } from '../../../core/services/onboarding.service.ts.service';
import { IconComponent } from '../../../shared/icon/icon.component';
import { Lista, ListService } from '../../../core/services/list.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-stepDescription',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './stepDescription.component.html',
  styleUrl: './stepDescription.component.scss',
})
export class StepDescriptionComponent implements OnInit {
  onboardingData: any;
  servizi: Lista[] = [];
  signUpUrl: string = '';
  refKey: string = '';

  contractRef: string = environment.contractRef;

  constructor(
    private router: Router,
    private onboardingService: OnboardingService,
    private listService: ListService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    // Recupera i dati salvati nel servizio
    this.onboardingData = this.onboardingService.getData();
    // console.log('Dati form ricevuti: ', this.onboardingData);

    this.listService.getServizi().subscribe((data) => {
      this.servizi = data;
    });

    /* // Se drfeelUser è true, esegui direttamente completeOnboarding
    if (this.onboardingData?.drfeelUser) {
      this.completeOnboarding();
    } */
  }

  completeOnboarding() {
    this.onboardingService.updateData({ stepDescriptionCompleted: true });

    let postData = {
      birthDate: this.onboardingData.birthDate,
      bornCity: '',
      country: this.onboardingData.birthCountry,
      email: this.onboardingData.email,
      firstName: this.onboardingData.firstName,
      gender: this.onboardingData.gender,
      groupRef: this.onboardingData.groupRef,
      lastName: this.onboardingData.lastName,
    };

    if (this.onboardingData.birthCountry === 'Italia') {
      postData = {
        ...postData,
        bornCity: this.onboardingData.birthCity,
      };
    } else {
      postData = {
        ...postData,
        bornCity: this.onboardingData.birthPlace,
      };
    }

    if (postData) {
      this.http
        .post<string>(
          `${environment.apiBaseUrl}/contact-pre-reg/${this.contractRef}`,
          postData,
          {
            responseType: 'text' as 'json',
          }
        )
        .subscribe(
          (response) => {
            this.refKey = response;
            // Riscatta il coupon via API, poi reindirizza alla pagina signup
            this.sendCouponRequest(this.refKey);
          },
          (error) => {
            console.error('Errore:', error);
          }
        );
    }
  }

  sendCouponRequest(refKey: string) {
    const couponPayload = {
      refCode: refKey,
      type: 'REF_CODE',
    };

    this.http
      .post(
        `${environment.apiBaseUrl}/contact-coupon/${this.contractRef}`,
        couponPayload,
        { responseType: 'text' }
      )
      .subscribe(
        (response) => {
          // La risposta è il codice coupon riscattato
          const redeemedCoupon = response;

          // Reindirizza alla pagina signup includendo refCode, contractRef E il coupon riscattato
          this.signUpUrl = `${environment.webappBaseUrl}/signup?refCode=${this.refKey}&contractRef=${this.contractRef}&couponCode=${redeemedCoupon}`;
          window.location.href = this.signUpUrl;
        },
        (error) => {
          console.error('Errore nel riscatto del coupon:', error);
          // In caso di errore nel riscatto, reindirizziamo comunque ma senza coupon code (il backend gestirà l'errore o l'utente lo inserirà dopo)
          this.signUpUrl = `${environment.webappBaseUrl}/signup?refCode=${this.refKey}&contractRef=${this.contractRef}`;
          window.location.href = this.signUpUrl;
        }
      );
  }

}

